// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/styling-" + {"63598":"5097533d921f1eea007d","98456":"0e70f9fe419da3804095"}[chunkId] + ".css";
};